module.exports = __webpack_public_path__ + "static/media/laravel.8a0f1223.png";